import { Component, DestroyRef, OnInit, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { SqlServerService } from "src/app/core/http/sql-server.service";
import { CreateEditSingleLessonService } from "src/app/core/services/lesson-services/create-edit-single-lesson.service";
import { LessonSearchService } from "src/app/core/services/lesson-services/lesson-search.service";
import { appInfo } from "src/environments/environment";
import { SharedService } from "../../shared.service";
import { CommonService } from "src/app/core/services/lesson-services/common.service";
import { CurrentUserService } from "src/app/core/http/current-user.service";
import { User } from "src/app/shared/models";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { ExtensionType } from "src/app/config/global-enums.config";
import { AppRoles} from "src/app/config/global-enums.config";

@Component({
  selector: "app-menubar",
  templateUrl: "./menubar.component.html",
  styleUrls: ["./menubar.component.scss"],
  imports: [CommonModule, RouterModule],
})
export class MenubarComponent implements OnInit {
  public feedbackUrl = appInfo.feedbackUrl;
  readonly extensionType = ExtensionType;

  userProfile: User;
  userRoles: string[] = [];

  selectedTab: any = "tab1";

  showReportedLessonsTab: boolean;
  showCoordinatorTab: boolean;
  showAdminPortalTab: boolean;

  pendingTasks = 0;

  private destroyRef = inject(DestroyRef);

  constructor(
    public shared: SharedService,
    public singleLessonService: CreateEditSingleLessonService,
    private lessonSearchService: LessonSearchService,
    private commonService: CommonService,
    private sqlServerService: SqlServerService,
    private currentUserService: CurrentUserService
  ) {}

  ngOnInit(): void {
    this.userProfile = JSON.parse(sessionStorage.getItem("profile-ell"));
    this.userRoles = sessionStorage.getItem("roles")?.split(",") ?? [];
    this.getCoordinatorStatus();
    this.getAdminStatus();
    this.getReportedLessonsTabStatus();
    this.currentUserService.currentTaskStatus
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((status) => (this.pendingTasks = status));
  }

  get pendingTasksBadge(): string {
    return this.pendingTasks > 9 ? "+9" : `${this.pendingTasks}`;
  }

  getCoordinatorStatus() {
    this.showCoordinatorTab = this.userRoles.some((ele) => ele.includes(AppRoles.SUPERADMINUI));
  }

  getAdminStatus() {
    this.showAdminPortalTab = this.userRoles.some((ele) => ele.includes(AppRoles.SUPERADMINUI));
  }

  getReportedLessonsTabStatus() {
    this.showReportedLessonsTab = this.userRoles.some((ele) => ele.includes(AppRoles.SUPERADMINUI));
  }

  onClick(check) {
    if (check == 4 && this.shared.tab == "tab3") {
      this.lessonSearchService.searchTrigger.next({
        scope: "AssignedLessons",
        searchText: "",
      });
      this.selectedTab = "tab3";
    } else {
      this.shared.onClick(check);
      this.selectedTab = this.shared.tab;
    }
  }
}
